export default __webpack_public_path__ + "static/media/user.48e5d04c.svg";